
import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { AddMarketplacePlatformModel } from "../../../../models/dashboard/marketplace/marketplaceModels";

 const addNewPlatform = (platform: AddMarketplacePlatformModel ): Promise<any> => {
  return adminHttpClient.post("/api/Admin/AdminMarketplace/add-platform", platform);
};
export  default addNewPlatform;